<template>
  <el-container class="fullheight">
    <el-aside v-show="asideShow" width="250px" class="sysmodule__preview-aside">
      <el-page-header
        style="padding: 10px; background: #eee"
        @back="$emit('close-dialog')"
      >
        <template #content>{{ $t('eip.common.preview') }}</template>
      </el-page-header>
      <el-menu
        default-active="0_0"
        class="el-menu-vertical-demo"
        style="border-right: none"
        @select="handleSelect"
      >
        <el-submenu
          v-for="(item, index) in menuData"
          :key="index"
          :index="index + ''"
        >
          <template slot="title">
            <i class="el-icon-menu"></i>
            {{ item.text }}
          </template>
          <el-menu-item-group>
            <el-menu-item
              v-for="(obj, index1) in item.children"
              :key="index1"
              :index="index + '_' + index1"
            >
              {{ obj.text }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow,
          }"
        ></i>
      </div>
    </div>
    <el-container>
      <iframe
        v-if="isShowIframe"
        id="myIframe"
        style="width: 100%"
        frameborder="0"
        allowtransparency="0"
        :src="iframeSrc"
      ></iframe>
      <ht-template-preview
        v-else-if="isDatalistList"
        :template-key="templateKey"
        :rkey="rkey"
        style="width: 100%"
      />
      <div v-else style="width: 100%">
        <ht-chart :id="chartId" :chart-key="chartId" />
      </div>
    </el-container>
  </el-container>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SysModulePreview',
    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        asideShow: true,
        workspaceList: [],
        datalistList: [],
        viewlistList: [],
        isShowIframe: true,
        chartId: '',
        iframeSrc: '',
        menuData: {},
        chartList: [],
        menuTypeList: [
          {
            type: 'workspaceList',
            name: this.$t('page.modulePreview.workspace'),
          },
          {
            type: 'datalistList',
            name: this.$t('page.modulePreview.datasheets'),
          },
          {
            type: 'viewlistList',
            name: this.$t('page.modulePreview.viewList'),
          },
          { type: 'chartList', name: this.$t('page.modulePreview.chartList') },
          { type: 'otherList', name: this.$t('page.modulePreview.otherList') },
        ],
        otherList: [],
        templateKey: '',
        isDatalistList: false,
      }
    },
    computed: {
      ...mapGetters('user', ['tokens']),
      rkey() {
        return `${Date.parse(new Date())}_${Math.ceil(Math.random() * 99999)}`
      },
    },
    watch: {
      'data.id': function () {
        this.init()
        this.initDetails(this.data)
        var menuData = []
        this.initMenuData(menuData)
        this.menuData = menuData
        this.templateKey = this.datalistList[0] ? this.datalistList[0].code : ''
      },
    },

    mounted() {
      this.initDetails(this.data)
      var menuData = []
      this.initMenuData(menuData)
      this.menuData = menuData
      this.templateKey = this.datalistList[0] ? this.datalistList[0].code : ''
    },
    created() {},
    methods: {
      init() {
        this.workspaceList = []
        this.datalistList = []
        this.viewlistList = []
        this.iframeSrc = ''
        this.menuData = {}
        this.chartList = []
        this.menuTypeList = [
          { type: 'workspaceList', name: '工作空间' },
          { type: 'datalistList', name: '数据列表' },
          { type: 'viewlistList', name: '视图列表' },
          { type: 'chartList', name: '图表列表' },
          { type: 'otherList', name: '栏目列表' },
        ]
        this.otherList = []
      },
      initDetails(data) {
        if (data.moduleDetail && data.moduleDetail.length > 0) {
          for (var i = 0; i < data.moduleDetail.length; i++) {
            var type = data.moduleDetail[i].type
            switch (type) {
              case 'workspace':
                this.workspaceList.push(data.moduleDetail[i])
                break
              case 'datalist':
                this.datalistList.push(data.moduleDetail[i])
                break
              case 'viewlist':
                this.viewlistList.push(data.moduleDetail[i])
                break
              case 'chart':
                this.chartList.push(data.moduleDetail[i])
                break
              case 'other':
                this.otherList.push(data.moduleDetail[i])
                break
            }
          }
        }
      },
      initMenuData(menuData) {
        for (var k = 0; k < this.menuTypeList.length; k++) {
          var type = this.menuTypeList[k].type
          if (this[type].length > 0) {
            var typeList = this[type]
            if (type == 'otherList') {
              var map = {}
              for (var i = 0; i < typeList.length; i++) {
                if (!map[typeList[i].columnName]) {
                  map[typeList[i].columnName] = typeList[i].columnName
                  const item = {
                    text: typeList[i].columnName,
                    children: [],
                  }
                  for (var n = 0; n < typeList.length; n++) {
                    if (typeList[i].columnName == typeList[n].columnName) {
                      var sub = {
                        text: typeList[n].name,
                        code: typeList[n].code,
                        type: type,
                        url: typeList[n].url,
                      }
                      item.children.push(sub)
                    }
                  }
                  menuData.push(item)
                }
              }
            } else {
              const item = {
                text: this.menuTypeList[k].name,
                children: [],
              }
              for (let i = 0; i < typeList.length; i++) {
                const sub = {
                  text: typeList[i].name,
                  code: typeList[i].code,
                  type: type,
                  url: typeList[i].url,
                }
                item.children.push(sub)
              }
              menuData.push(item)
            }
          }
        }
        if (menuData.length > 0) {
          let item = menuData[0].children[0]
          this.iframeSrc = this.getUrl(item.url, item.type)
        }
      },
      handleSelect(index) {
        const path = index.split('_')
        if (path.length > 1) {
          let item = this.menuData[path[0]].children[path[1]]
          if (item.type === 'datalistList') {
            this.templateKey = item.code
          }
          this.iframeSrc = this.getUrl(item.url, item.type)
        }
      },
      getUrl(url, type) {
        this.isShowIframe = true
        if (type === 'datalistList') {
          this.isDatalistList = true
        } else if (
          url.includes('templatePreview') &&
          type === 'workspaceList'
        ) {
          this.templateKey = url.split('/')[2] || ''
          this.isDatalistList = true
        } else {
          this.isDatalistList = false
        }
        var iframeSrc = url
        switch (type) {
          case 'workspaceList':
            this.isShowIframe = this.isDatalistList ? false : true
            iframeSrc = `${window.context.front}${url}?token=${this.tokens.token}&rtoken=${this.tokens.rtoken}`
            break
          case 'datalistList':
            this.isShowIframe = false
            break
          case 'viewlist':
            break
          case 'chartList':
            this.isShowIframe = false
            this.chartId = url
            break
        }
        return iframeSrc
      },
    },
  }
</script>
<style lang="scss" scoped>
  ::v-deep .navbar-collapse {
    z-index: 9999;
    width: 0;
    margin-top: 50px;
  }
  ::v-deep .navbar-collapse-bg {
    position: relative;
    height: 28px;
    margin-left: 1px;
    border-top: 8px solid transparent;
    border-right: none;
    border-bottom: 8px solid transparent;
    border-left: 10px solid #f5f5f5;
  }
  ::v-deep .navbar-collapse-bg:hover {
    cursor: pointer;
  }
  ::v-deep .navbar-collapse-arrow {
    position: absolute;
    top: 7px;
    left: -12px;
  }
  ::v-deep .el-tabs__content {
    padding-left: 20px;
  }
  .sysmodule__preview-aside {
    background: #f5f5f5;
    border-right: 1px solid #eee;
  }
  .el-menu-vertical-demo,
  ::v-deep .el-menu-item-group {
    background: #f5f5f5;
  }
</style>
